import type { FC, ReactNode } from "react";

export type FieldWrapperProps = {
  label?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: ReactNode;
};

/**
 * フォームフィールドの共通器。label, required バッジ, hint, error を統一描画する。
 * ui/Input 等のリーフを children として受け取る。
 * @param {FieldWrapperProps} props FieldWrapper の props
 * @return {JSX.Element} ラベル・エラー付きのフィールドコンテナ
 */
export const FieldWrapper: FC<FieldWrapperProps> = ({
  label,
  required,
  hint,
  error,
  children,
}) => {
  return (
    <div className="form-control w-full">
      {label && (
        <label className="label">
          <span className="label-text font-medium">{label}</span>
          {required && <span className="label-text-alt text-error">必須</span>}
        </label>
      )}
      {children}
      {error && (
        <label className="label">
          <span className="label-text-alt text-error">{error}</span>
        </label>
      )}
      {!error && hint && (
        <label className="label">
          <span className="label-text-alt text-base-content/50">{hint}</span>
        </label>
      )}
    </div>
  );
};
